var shorthand = function shorthand(token) {
  if (!token) {
    return undefined;
  }
  var _token$width = token.width,
    width = _token$width === void 0 ? '' : _token$width,
    _token$style = token.style,
    style = _token$style === void 0 ? '' : _token$style,
    _token$color = token.color,
    color = _token$color === void 0 ? '' : _token$color;
  if (!width) {
    return null;
  }
  return "".concat(width, " ").concat(style, " ").concat(color);
};

export { shorthand };
